import script from "./AdminLimites.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLimites.vue?vue&type=script&setup=true&lang=js"

import "./AdminLimites.vue?vue&type=style&index=0&id=54082b1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54082b1a"]])

export default __exports__